<template>
    <div class="templateEmergency">
            <h4 class=" text-center text-secondary pt-5"> အရေးပေါ်လူနာတင်လူနာတင်ယာဉ်အကူအညီ </h4>
             <div class="row m-5">
                        <div class=" col-md-5 mx-auto d-block card m-3 p-4 card-glass " v-for="emy in emergency" :key="emy.id">
                                <div class="card-body">
                                    <h5 class="card-title text-danger"> {{emy.name}}</h5>
                                    <div class="row">
                                        <div class="col-md-6 mt-3">
                                                <div class="row">
                                                            <div class="col">
                                                                    <span class="link-dark">ဖုန်း - </span>
                                                            </div>
                                                            <div class="col">
                                                                        <div class="mb-1">
                                                                            <a :href="'tel:'+emy.ph" class=" text-decoration-none">  {{emy.ph}}</a> 
                                                                        </div>

                                                                        <div class="mb-1">
                                                                            <a :href="'tel:'+emy.ph1" class=" text-decoration-none">  {{emy.ph1}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+emy.ph2" class=" text-decoration-none">   {{emy.ph2}}</a> 
                                                                        </div>

                                                                            <div class="mb-1">
                                                                            <a :href="'tel:'+emy.ph3" class=" text-decoration-none">  {{emy.ph3}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+emy.ph4" class=" text-decoration-none">  {{emy.ph4}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+emy.ph5"  class=" text-decoration-none"> {{emy.ph5}}</a> 
                                                                        </div>
                                                            </div>

                                                    </div>
                                                  
                                            </div>
                                              <small class="text-muted mt-2"> ဖုန်းနံပါတ်ကိုနှိပ်ပြီးခေါ်ဆိုနိုင်ပါသည် </small>
                                    </div>
                                   
                                   
                                 
                                    
                                </div>
                        </div>      

            </div>        
           
        </div>
  
</template>

<script>
export default {
    name: 'Emergency',

    data(){
        return {
    emergency : [
        {name:'ရွှေလောင်းလှေ' , ph:'+9599754924542'},
        {name:'ဝေဠုကျော်ဖောင်ဒေးရှင်း', ph:'+959455500014', ph1:'+959979753212',ph2:'+959455500010'},
         {name:'အနှိုင်းမဲ့ဂရုဏာရှင်', ph:'+959252573847'},
         {name:'ဥဒေါင်းလူမှုကူညီရေး' , ph:'+959950775792'},
         {name:'ကြက်ခြေနီ (အင်းစိန်)', ph:'+959970025002'},
          {name:'ရှားသူလူမှုကူညီရေး', ph:'+959421717150'},
          {name:'ရွှေကံသာလူကူညီရေး' , ph:'+959451972251', ph1:'+959267287228'},
         {name:'လှိုင်သာယာအရေးပေါ်ကား', ph:'+959420295617', ph1:'+9595124891'},
          {name:'ရှင်သန်ရေး (မနိုင်)', ph:'+959250794791'},
          {name:'မင်းမင်းထွန်း' , ph:'+959955147950', ph1:'+959965147950'},
          {name:'စေတနာလူမှုကူညီရေး', ph:'+959254839779', ph1:'+959253381448', ph2:'+959972488855', ph3:'+959250080010', ph4:'+959440470636', ph5:'+959793622114'},
          {name:'လင်းလတ်', ph:'+959262239600'},

    ]
    }

    }

  
}
</script>

<style>
 .templateEmergency {
       
          background:linear-gradient(to right top, #f7e9be, #e2e8e9);
        
          align-items: center;
          justify-content: center;
          
        }

</style>